module.exports = __webpack_public_path__ + "media/crow.276e927a.wav";